<template>
  <v-dialog v-model="propDialogo" width="400px" persistent>
    <v-card style="padding: 15px">
      <v-icon class="ma-1 right top" style="position: absolute" color="#0D47A1" large
        @click="$emit('closeDialogo')">mdi-close-circle</v-icon>
      <div style="text-align: center; justify-content: center">
        <div class="ml-4 mr-4">
          <h1 style="line-height: 1.2; color: black; text-align: center">
            DETALLES DEL CURSO
          </h1>
        </div>
       <br>
          <curso :propCurso="propCurso" />       
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import curso from "@/components/template/curso";
export default {
components:{
  curso,
},
  props: {
    propDialogo: { type: Boolean },
    propCurso: { type: Object }
  },
  data() {
    return {
    };
  },
  mounted() { },
  watch: {},
  methods: {
  },
};
</script>
<style scoped></style>
